import AppLayout from "@/layouts/AppLayout";
import { Navigate, Outlet } from "react-router-dom";
import { PersonObjectHeading } from "@/features/person/components/PersonObjectHeading";
import { usePersonErrorHandling } from "../_components/usePersonErrorHandling";
import PersonNotFoundErrorBoundary from "../_components/PersonNotFoundErrorBoundary";
import TabLayout from "./_TabLayout";
import { useIsCompactLayout } from "@/hooks/useIsCompactLayout";
import Breadcrumb from "@/components/Breadcrumb";
import { usePersonEventsAccess } from "./_usePersonEventsAccess";

export default function PersonEventsLayout() {
  const { isCompactLayout: isMobile } = useIsCompactLayout();
  const { pgaId, navLinks, shouldRenderError } = usePersonErrorHandling();
  const { loaded, canViewPersonEvents } = usePersonEventsAccess();

  if (shouldRenderError || !pgaId) {
    return (
      <AppLayout navLinks={[]} interior bottomBar>
        <PersonNotFoundErrorBoundary />
      </AppLayout>
    );
  }

  if (loaded && !canViewPersonEvents) {
    return (
      <AppLayout navLinks={navLinks} interior bottomBar>
        <Navigate to={`/people/${pgaId}/person/overview`} replace />
      </AppLayout>
    );
  }

  if (!loaded) {
    return (
      <AppLayout navLinks={navLinks} interior bottomBar>
        {isMobile ? (
          <Breadcrumb compactOnly compactTitle="Events" backLink={{ to: "/people/:pgaId", params: { pgaId } }} />
        ) : null}
        <PersonObjectHeading pgaId={pgaId} />
      </AppLayout>
    );
  }

  const renderDesktopLayout = () => (
    <>
      <PersonObjectHeading pgaId={pgaId} />
      <TabLayout>
        <Outlet />
      </TabLayout>
    </>
  );

  const renderMobileLayout = () => (
    <>
      <Breadcrumb compactOnly compactTitle="Events" backLink={{ to: "/people/:pgaId", params: { pgaId: pgaId! } }} />
      <PersonObjectHeading pgaId={pgaId} />
      <TabLayout>
        <Outlet />
      </TabLayout>
    </>
  );

  return (
    <AppLayout navLinks={navLinks} interior bottomBar>
      {isMobile ? renderMobileLayout() : renderDesktopLayout()}
    </AppLayout>
  );
}
